import * as React from 'react';
import { Button } from '@/src/shadComponents/ui/button';
import { Badge } from '@/src/shadComponents/ui/badge';

/*
 * /v2 index — design-system playground (chrome comes from V2Frame).
 * Proves the scoped tokens and that existing shadcn primitives restyle
 * inside the .psv2 subtree. Reference: docs/design-system/.
 */

export default function Playground() {
    return (
        <main className="mx-auto max-w-[880px] px-[clamp(18px,3vw,34px)] pt-6">
            <p className="mb-8 text-[13px] text-muted-foreground">
                This is the v2 design system rendering inside the real app.
                Everything below is a v2 pattern or an existing shadcn
                primitive picking up the scoped tokens. Try the dock —
                Activations is live.
            </p>

            <section className="mb-9">
                <div className="ps-label mb-3">Buttons · shadcn, restyled</div>
                <div className="flex flex-wrap items-center gap-3">
                    <Button className="rounded-full">New activation</Button>
                    <Button variant="outline" className="rounded-full">
                        Preview
                    </Button>
                    <Badge className="rounded-full bg-good-soft text-good hover:bg-good-soft">
                        ● Live
                    </Badge>
                    <Badge className="rounded-full bg-good-soft text-good hover:bg-good-soft">
                        +38 today
                    </Badge>
                </div>
            </section>

            <section className="mb-9">
                <div className="ps-label mb-3">Underline input</div>
                <div className="max-w-[300px]">
                    <label className="mb-1.5 block text-xs font-semibold text-muted-foreground">
                        Gallery name
                    </label>
                    <input className="ps-input" defaultValue="Summer Gala" />
                </div>
            </section>

            <section className="mb-9">
                <div className="ps-label mb-3">Status vocabulary</div>
                <div className="flex flex-col gap-1.5 text-xs font-semibold">
                    <span className="flex items-center gap-2 text-good">
                        <span className="ps-pulse" />
                        Live · 2 devices
                    </span>
                    <span className="text-good">Ready · 3 devices</span>
                    <span className="text-attention">No devices assigned</span>
                    <span className="text-attention">
                        Experience not published
                    </span>
                    <span className="font-normal text-faint">Not started</span>
                </div>
            </section>

            <section className="mb-9">
                <div className="ps-label mb-3">Hairline rows</div>
                <div className="max-w-[420px]">
                    {['Public gallery', 'Sharing station', 'Slideshow'].map(
                        (t, i) => (
                            <div
                                key={t}
                                className={
                                    'flex items-center gap-2.5 py-2.5 text-[12.5px] font-semibold' +
                                    (i > 0 ? ' border-t border-line' : '')
                                }
                            >
                                <span className="h-[26px] w-[26px] rounded-[7px] bg-secondary" />
                                {t}
                                <span className="ml-auto font-mono text-[10.5px] font-normal text-faint">
                                    ⧉ ↗
                                </span>
                            </div>
                        ),
                    )}
                </div>
            </section>
        </main>
    );
}
